"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Day = Day;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var styles = _interopRequireWildcard(require("./styles.css"));
var _helpers = require("../../utils/helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Day(_ref) {
  let {
    from,
    to,
    date,
    availabilityArray,
    getShowTooltip,
    tooltipText
  } = _ref;
  const ref = React.useRef(null);
  const day = (0, _dateFns.getDate)(date);
  const dayStatus = (0, _helpers.getDayStatus)(availabilityArray, date);
  const isDisabled = dayStatus === 0;
  const isOnlyCheckout = dayStatus === 2;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: (0, _classnames.default)(styles['day'], isDisabled && styles['disabled'], isOnlyCheckout && styles['grey'])
  }, day, getShowTooltip(date) && /*#__PURE__*/React.createElement(_uiKit.CustomTooltip, {
    maxWidth: 150,
    onClose: () => {},
    anchorRef: ref,
    open: true,
    content: /*#__PURE__*/React.createElement(_uiKit.UIText2, {
      color: "white_100"
    }, tooltipText),
    placement: "top",
    theme: "black",
    size: "M",
    flip: true,
    arrow: true,
    portal: false,
    preventOverflow: true
  }));
}